import { render, staticRenderFns } from "./canshupeizhi.vue?vue&type=template&id=07f0e8c6&"
import script from "./canshupeizhi.vue?vue&type=script&lang=js&"
export * from "./canshupeizhi.vue?vue&type=script&lang=js&"
import style0 from "./canshupeizhi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports